import { useEffect, useState } from 'react'
import type { ImageItem } from '../api/types'

export function ImageSlider({ images, interval = 6000 }: { images: ImageItem[]; interval?: number }) {
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    if (images.length <= 1) return
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length)
    }, interval)
    return () => clearInterval(timer)
  }, [images.length, interval])

  if (!images.length) return null

  return (
    <div className="image-slider">
      {images.map((img, i) => (
        <div
          key={img.id}
          className={`slider-slide ${i === current ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img.image})` }}
        />
      ))}
      {images.length > 1 && (
        <div className="slider-dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`slider-dot ${i === current ? 'active' : ''}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
